import React, { Component } from "react";
import OutfitSummaryPanelView from "presentational/upload/OutfitSummaryPanelView";
import PropTypes from "prop-types";

class OutfitSummaryPanel extends Component {
  static propTypes = {
    stickeredImageDataURL: PropTypes.string.isRequired,
    itemList: PropTypes.array.isRequired,
    calendarDate: PropTypes.string.isRequired,
    calendarAgreement: PropTypes.bool.isRequired,
    onBackClick: PropTypes.func.isRequired,
    onSubmitClick: PropTypes.func.isRequired
  };

  render() {
    const {
      stickeredImageDataURL,
      itemList,
      onBackClick,
      onSubmitClick,
      calendarDate,
      calendarAgreement
    } = this.props;
    return (
      <OutfitSummaryPanelView
        stickeredImageDataURL={stickeredImageDataURL}
        itemList={itemList}
        calendarDate={calendarDate}
        calendarAgreement={calendarAgreement}
        onBackClick={onBackClick}
        onSubmitClick={onSubmitClick}
      />
    );
  }
}

export default OutfitSummaryPanel;
